import type { FC } from "react";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ContactList from "../components/contactlist";
import RegisterContact from "../components/registercontact";
import CreateContactList from "../components/createcontactlist";
import ContactLists from "../components/contactlists";
import AppContext from "../utils/appContext";
import Footer from "../components/footer";
import { Button, Modal, PageShell, Toolbar } from "../components/ui";

//make an infterface for the props
const Contacts: FC = () => {
  const [counter, setCounter] = useState(0);
  const [user] = useState(JSON.parse(localStorage.getItem("user") || "{}"));
  const [showMap, setShowMap] = useState(false);
  const [showAddContact, setShowAddContact] = useState(false);
  const [showCreateContactList, setShowCreateContactList] = useState(false);
  const [showManageContactLists, setShowManageContactLists] = useState(false);
  const context = useContext(AppContext);
  const navigate = useNavigate();
  const updateCounter = () => {
    setCounter(counter + 1);
  };
  const checkStatus = async () => {
    const storedJWT = localStorage.getItem("jwt");

    if (storedJWT) {
      await fetch(process.env.REACT_APP_API_URL + "/check-status.php", {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + storedJWT,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data === "success") {
          } else {
            localStorage.clear();
            context?.updateLoginStatus(false);
            navigate("/login");
          }
        })
        .catch((error) => {
          // Handle network or server errors
          console.error();
          localStorage.clear();
          context?.updateLoginStatus(false);
          navigate("/login");
        });
    } else {
      localStorage.clear();
      context?.updateLoginStatus(false);
      navigate("/login");
    }
  };
  const toggleAddContactModal = () => {
    setShowAddContact(!showAddContact);
    setShowCreateContactList(false);
    setShowManageContactLists(false);
  };
  const toggleCreateContactListModal = () => {
    setShowCreateContactList(!showCreateContactList);
    setShowAddContact(false);
    setShowManageContactLists(false);
  };
  const toggleManageContactListsModal = () => {
    setShowManageContactLists(!showManageContactLists);
    setShowCreateContactList(false);
    setShowAddContact(false);
  };
  useEffect(() => {
    checkStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const roles = JSON.parse(user.groups || "[]");

  return (
    <>
      <PageShell>
        <Toolbar className="mb-3">
          {process.env.REACT_APP_CONTACTS_CAN_CREATE_USER === "true" && (
            <Button onClick={toggleAddContactModal}>Add a contact</Button>
          )}
          {process.env.REACT_APP_CONTACTS_CAN_CREATE_GROUP === "true" && (
            <Button onClick={toggleCreateContactListModal}>
              Create a contact list
            </Button>
          )}
          {process.env.REACT_APP_CONTACTS_CAN_MANAGE_GROUP === "true" && (
            <Button onClick={toggleManageContactListsModal}>
              Manage contact lists
            </Button>
          )}
          {process.env.REACT_APP_MAP === "true" && (
            <Button onClick={() => setShowMap(!showMap)}>
              {showMap ? "Show list" : "Show map"}
            </Button>
          )}
        </Toolbar>
        <ContactList refreshCounter={counter} showMap={showMap} />
        {(roles.includes(0) || roles.includes(1)) && showAddContact && (
          <Modal isOpen={showAddContact} maxWidth="md" scroll>
            <RegisterContact
              toggleAddContactModal={toggleAddContactModal}
              refreshCounter={counter}
              refresh={updateCounter}
            />
          </Modal>
        )}
        {(roles.includes(0) || roles.includes(1)) && showCreateContactList && (
          <Modal isOpen={showCreateContactList} maxWidth="sm">
            <CreateContactList
              toggleCreateContactListModal={toggleCreateContactListModal}
              refresh={updateCounter}
            />
          </Modal>
        )}
        {(roles.includes(0) || roles.includes(1)) && showManageContactLists && (
          <Modal isOpen={showManageContactLists} maxWidth="sm">
            <ContactLists
              toggleManageContactListsModal={toggleManageContactListsModal}
              refresh={updateCounter}
            />
          </Modal>
        )}
      </PageShell>
      <Footer />
    </>
  );
};
export default Contacts;
